module.exports = __webpack_public_path__ + "static/media/thumb_bizly.ddac24fd.png";